<template>
  <header v-if="isLoggedIn" class="header">
    <a :href="hrefTopLink" class="nav-home"><svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24"><path fill="#00913a" d="m12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81zM12 3L2 12h3v8h6v-6h2v6h6v-8h3"/></svg></a>
    <a :href="hrefTopLink" class="nav-logo"></a>
  </header>

  <header v-else class="header">
    <a href="/" class="nav-logo"></a>
  </header>
</template>

<script>
  import {appName, api} from '../../config';
  import {mapGetters} from 'vuex';

  export default {
    data() {
      return {
        appName: appName,
        logout_modal: false,
        currentYear: (new Date).getFullYear()
      }
    },
    created() {
    },

    computed: {
      isLoggedIn() {
        const authUser = this.$store.getters.getAuthUser;
        if(authUser) {
          return true;
        } else {
          return false;
        }
      },
      hrefTopLink() {
        return window.global.jsl_front_url + "/survival";
      },
    },

    methods: {
      logout() {
        this.logout_modal = true;
      },
      close() {
        this.logout_modal = false;
      }
    },
  }
</script>
<style lang="scss">


</style>
